export const PAGE_LOAD_TIMING_MARKS = {
    sdkJS: "sdkJS",
    publicData: "publicData",
    iFrameJS: "iFrameJS",
    sdkInit: "sdkInit",
} as const;

const pageLoadTimings: Record<string, number> = {};

export function markPageLoadTiming(key: string): void {
    pageLoadTimings[key] = performance.now() | 0; // Convert to int
}

export function getPageLoadTimings(): Record<string, number> {
    return pageLoadTimings;
}
